import {FormArray} from '@angular/forms';

export class FormUtil {

	static clearFormArray(formArray: FormArray) {
		while (formArray.length > 0) {
			formArray.removeAt(0);
		}
		formArray.reset();
	}
}
